<template>
  <div class="content album-list-page">

    <!-- ── Page header ─────────────────────────────────────────────────────── -->
    <div class="page-header-card">
      <div>
        <h2 class="page-title">Quản lý Album</h2>
        <p class="page-description">Tìm kiếm, duyệt và quản lý toàn bộ album ảnh của trường.</p>
      </div>
      <div class="header-badges">
        <div class="summary-badge">
          <span class="summary-badge__label">Tổng số album</span>
          <strong class="summary-badge__value">{{ total || 0 }}</strong>
        </div>
        <div class="summary-badge">
          <span class="summary-badge__label">Đang chọn</span>
          <strong class="summary-badge__value">{{ listIdApproveAlbum.length }}</strong>
        </div>
      </div>
    </div>

    <!-- ── Toolbar ─────────────────────────────────────────────────────────── -->
    <div class="toolbar-card">
      <div class="toolbar-left">
        <el-date-picker
            :clearable="true"
            class="toolbar-datepicker"
            value-format="yyyy-MM-dd"
            format="dd-MM-yyyy"
            v-model="dataSearch.dateList"
            type="daterange"
            unlink-panels
            range-separator="→"
            @change="searchByProperties()"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc"
        />

        <el-select
            v-model="dataSearch.idClass"
            @change="searchHeaderMethod()"
            placeholder="Chọn lớp"
            clearable
            class="toolbar-select"
        >
          <el-option
              v-for="item in listClass"
              :key="item.id"
              :label="item.className"
              :value="item.id"
          />
        </el-select>

        <el-select
            v-if="getAppTypeUserLogin === 'plus'"
            v-model="dataSearch.albumType"
            @change="searchHeaderMethod()"
            placeholder="Loại album"
            clearable
            class="toolbar-select"
        >
          <el-option v-for="item in albumTypesOption" :key="item" :label="item" :value="item"/>
        </el-select>

        <el-select
            v-if="getAppTypeUserLogin === 'plus'"
            v-model="dataSearch.hideAndShow"
            @change="searchHeaderMethod()"
            placeholder="Trạng thái"
            clearable
            class="toolbar-select"
        >
          <el-option v-for="(item, index) in statusAlbum" :key="index" :label="item.label" :value="item.value"/>
        </el-select>
      </div>

      <div class="toolbar-right" v-if="checkPermission(['studentQuality_ablum_update'])">
        <router-link :to="{ path: '/student-quality/album/add' }" class="cancel-link">
          <el-button type="success" icon="el-icon-plus" class="btn-action">Tạo Album</el-button>
        </router-link>

        <el-dropdown @command="handleCommandAction" trigger="click">
          <el-button type="primary" class="btn-action">
            Tác vụ <i class="el-icon-caret-bottom"/>
          </el-button>
          <el-dropdown-menu class="album-dropdown-menu">
            <el-dropdown-item command="approveAlbum">
              <i class="el-icon-check"/> Duyệt Album
            </el-dropdown-item>
            <el-dropdown-item command="unApproveAlbum">
              <i class="el-icon-close"/> Hủy duyệt Album
            </el-dropdown-item>
            <el-dropdown-item command="deleteMultiAlbum">
              <i class="el-icon-delete"/> Xóa Album
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- ── Album grid ──────────────────────────────────────────────────────── -->
    <div class="grid-shell" v-if="total > 0">
      <!-- Select-all bar -->
      <div class="select-bar">
        <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="isCheckAll"
            @change="handleCheckAllChange"
        >
          Chọn tất cả
        </el-checkbox>
        <span class="select-bar__count" v-if="listIdApproveAlbum.length > 0">
          Đã chọn {{ listIdApproveAlbum.length }} album
        </span>
      </div>

      <div class="album-grid">
        <div
            v-for="albumResponse in albumResponseList"
            :key="albumResponse.id"
            class="album-card"
            :class="{ 'album-card--selected': albumResponse.checkApprove }"
        >
          <!-- Thumbnail -->
          <router-link
              :to="{ path: '/student-quality/album-detail/' + albumResponse.id }"
              class="album-card__cover-link"
          >
            <div class="album-card__cover">
              <TagFlag title="Mới" v-if="albumResponse.albumNew || albumResponse.urlPictureFirst === null"/>

              <el-image
                  v-if="albumResponse.urlPictureFirst != null"
                  class="album-card__img"
                  :src="albumResponse.urlShowPicture"
                  fit="cover"
              />
              <div v-else class="album-card__no-img">
                <i class="el-icon-picture-outline album-card__no-img-icon"/>
                <span>Chưa có ảnh</span>
              </div>

              <!-- Status badge -->
              <div
                  class="album-card__status-badge"
                  :class="albumResponse.albumView ? 'badge--visible' : 'badge--hidden'"
              >
                {{ albumResponse.albumView ? 'Đang hiện' : 'Đã ẩn' }}
              </div>
            </div>
          </router-link>

          <!-- Info -->
          <div class="album-card__info">
            <router-link
                :to="{ path: '/student-quality/album-detail/' + albumResponse.id }"
                class="album-card__name-link"
            >
              <div class="album-card__name">{{ albumResponseAlbumName(albumResponse) }}</div>
            </router-link>

            <div class="album-card__meta">
              <span class="album-card__meta-item" v-if="albumResponse.className">
                <i class="el-icon-office-building"/> {{ albumResponse.className }}
              </span>
              <span class="album-card__meta-item" v-if="albumResponse.albumType">
                <i class="el-icon-collection-tag"/> {{ albumResponse.albumType }}
              </span>
              <span class="album-card__meta-item">
                <i class="el-icon-picture" style="color:#6298d0"/> {{ albumResponse.pictureNumber }} ảnh
              </span>
            </div>

            <div class="album-card__footer">
              <el-checkbox
                  v-model="albumResponse.checkApprove"
                  :key="albumResponse.id"
                  @change="(val) => checkApproveAlbum(albumResponse.id, val)"
              />
              <span class="album-card__date">{{ albumResponse.createdDate | formatDateTime }}</span>
            </div>

            <!-- Action bar -->
            <div
                class="album-card__actions"
                :class="albumResponse.albumView ? 'actions--visible' : 'actions--hidden'"
            >
              <el-button
                  size="mini"
                  :loading="albumResponse.checkDownload"
                  @click="download1(albumResponse)"
                  class="album-card__action-btn"
                  icon="el-icon-download"
              >Tải về</el-button>

              <el-button
                  v-if="checkPermission(['studentQuality_ablum_update'])"
                  size="mini"
                  @click="deleteAlbum(albumResponse.id)"
                  class="album-card__action-btn album-card__action-btn--danger"
                  icon="el-icon-delete"
              >Xóa</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Empty state ─────────────────────────────────────────────────────── -->
    <div v-else class="empty-state">
      <i class="el-icon-folder-opened empty-state__icon"/>
      <div class="empty-state__title">Chưa có album nào</div>
      <div class="empty-state__desc">Thay đổi bộ lọc hoặc tạo album mới để bắt đầu.</div>
      <router-link
          v-if="checkPermission(['studentQuality_ablum_update'])"
          :to="{ path: '/student-quality/album/add' }"
          class="cancel-link"
      >
        <el-button type="success" icon="el-icon-plus" class="btn-action">Tạo Album</el-button>
      </router-link>
    </div>

    <!-- ── Pagination ──────────────────────────────────────────────────────── -->
    <div v-if="total > 0" class="pagination-wrap">
      <el-pagination
          background
          @size-change="handleSizeChange"
          :current-page.sync="pageNumber"
          @current-change="handleCurrentChange"
          :page-sizes="listPageSize"
          :page-size="maxPageItem"
          :layout="$pageLayoutDefault"
          :total="total"
      />
    </div>

  </div>
</template>

<script>
import checkPermission from "@/utils/permission.js";
import AlbumService from "../../services/AlbumService";
import {mapState} from "vuex";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import TagFlag from "@/views/tag/TagFlag.vue";


export default {
  components: {TagFlag},
  data() {
    return {
      listPageSize: [30, 60, 120, 240, 480],
      statusAlbum: [
        {
          label: "Đã ẩn",
          value: false
        },
        {
          label: "Đang hiện",
          value: true,
        }
      ],
      currentPagePagination: 1,
      pageTotal: this.$pageTotalDefault,
      maxPageItem:30,
      pageNumber: 1,
      // listClass: [],
      layout: "sizes, prev, pager, next",
      total: undefined,
      pageSize: 12,
      currentPageNumber: 1,
      showProgress: false,
      albumTypesOption: ["Trường", "Lớp"],
      checkApprove: false,
      listIdApproveAlbum: [],
      // offset : this.currentPageNumber*this.pageSize-this.pageSize,
      pageList: [3, 6, 8, 10],
      multipleSelectionEmployee: [],
      showCreateDialog: false,
      showUpdateDialog: false,
      employeeData: [],
      statusEmployee: [],
      departmentList: [],
      idList: [],
      // listGrade: [],
      dataSearch: {
        idGrade: "",
        idClass: "",
        albumType: "",
        dateList: ["", ""],
        hideAndShow: "",
      },
      albumResponseList: [],
      isCheckAll: false,
      isIndeterminate: false,
    };
  },
  created() {
    if (this.getAppTypeUserLogin === "plus") {
      this.$store.dispatch('classStore/fetchDataClassListCommon');
    } else {
      this.$store.dispatch('classStore/fetchDataClassInTeacher');
    }
  },
  computed: {
    ...mapState('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    // eslint-disable-next-line vue/return-in-computed-property
    listClass() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon;
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      }
      return [];
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
  watch: {
    listClass: {
      handler(newVal) {
        if (newVal.length > 0 && this.getAppTypeUserLogin === "teacher") {
          this.getIdClassInTeacher();
        }
      },
    },

    listIdApproveAlbum(newVal) {
      if (newVal.length === 0) {
        this.isCheckAll = false;
        this.isIndeterminate = false;
      } else if (newVal.length > 0 && newVal.length < this.albumResponseList.length) {
        this.isCheckAll = false;
        this.isIndeterminate = true;
      } else if (newVal.length > 0 && newVal.length === this.albumResponseList.length) {
        this.isCheckAll = true;
        this.isIndeterminate = false;
      }
    }
  },
  methods: {
    handleCheckAllChange(val) {
      const data = this.albumResponseList;
      data.forEach((item) => {
        item.checkApprove = val;

        this.checkApproveAlbum(item.id, val);
      })


    },
    checkPermission,
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    //highlight cho row theo điều kiện
    tableRowStyle({row}) {
      row.id;
    },
    getIdClassInTeacher() {
      this.dataSearch.idClass = this.classList.filter((x) => x.checked)[0].id;
      this.searchByProperties();
    },
    // click chọn số bản ghi trên 1 trang
    handleSizeChange(maxPageItem) {
      this.maxPageItem = maxPageItem;
      this.searchByProperties();
    },
    //click chọn số trang
    handleCurrentChange(pageNumber) {
      this.currentPagePagination = pageNumber
      this.pageNumber = pageNumber;
      this.searchByProperties();
    },
    handleCommandAction(command) {
      switch (command) {
        case "approveAlbum" :
          this.updateMultiApproveAlbumMethod();
          break;
        case "unApproveAlbum" :
          this.updateMultiUnApproveAlbum();
          break;
        case "deleteMultiAlbum" :
          this.deleteMultiAlbum();
          break;
      }
    },

    //click checkbox of row
    handleSelectionChange(val) {
      this.multipleSelectionEmployee = val;
    },
    //click edit at row
    handleEdit(index, row) {
      this.showUpdateDialog = true;
      console.log(row);
    },
    //click delete at row
    handleDelete(index, row) {
      // console.log("delete " + index, row);
      this.$confirm(
          "Bạn có chắc chắn muốn xóa nhân viên đã chọn?",
          "Thông báo!"
      );
      console.log(row);
    },
    createEmployeeDialog() {
      this.showCreateDialog = true;
    },
    dialogCloseCreateMethod() {

      this.showCreateDialog = false;
      this.searchByProperties();
    },
    dialogCloseUpdateMethod() {
      // this.getAllClass();
      this.showUpdateDialog = false;
      this.searchByProperties();
    },
    searchHeaderMethod() {
      this.pageNumber = 1;
      this.currentPagePagination = 1;
      this.searchByProperties();
    },
    checkDateList() {
      if (this.dataSearch.dateList == null) {
        this.dataSearch.dateList = ["", ""];
      }
    },
    searchByProperties() {
      this.listIdApproveAlbum = [];
      this.checkDateList();
      AlbumService.searchalbumNew(
          this.pageNumber,
          this.maxPageItem,
          this.dataSearch.dateList[0],
          this.dataSearch.dateList[1],
          this.dataSearch.idGrade,
          this.dataSearch.idClass,
          this.dataSearch.albumType,
          this.dataSearch.hideAndShow,
      )
          .then((resp) => {
            this.albumResponseList = resp.data.data.responseList.map(item => {
              return {
                ...item,
                checkDownload: false
              };
            });

            this.total = resp.data.data.total;
            this.resetCheckAll();
            // this.getTotalRows();
          })
          .catch((err) => {
            this.total = 1;
            console.log(err);
            this.albumResponseList = [];
          });
    },

    getTotalRows() {
      AlbumService.getTotalItems().then((res) => {
        this.total = res.data.data;
      });
    },
    download1(album) {
      album.checkDownload = true;
      AlbumService.dowloadAlbum1(album.id)
          .then((response) => {
            this.reponse = response.data.data;
            const link = document.createElement("a");
            link.href = this.reponse;
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            console.log(err);
          }).finally(() => {
        setTimeout(() => {
          album.checkDownload = false;
          NotifyMessage.leftCornerNotificationSuccess("Tải album thành công!")
        }, 3000);

      })
    },
    deleteAlbum(id) {
      this.$confirm(
          "Bạn có chắc chắn muốn xóa Album ảnh đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        AlbumService.deleteAlbum(id)
            .then((res) => {
              if (res.data) {
                NotifyMessage.leftCornerNotificationSuccess("Xóa album thành công!")
                this.searchByProperties();
                // this.$router.go("/student-quality/album");
                this.$store.dispatch("notificationNavbarStore/fetchNotification");
              } else {
                NotifyMessage.leftCornerNotificationError("Xóa album thất bại")
              }
            })
            .catch((err) => {
              console.log(err);
              NotifyMessage.leftCornerNotificationError("Lỗi xóa ảnh")
            });
      });
    },
    deleteMultiAlbum() {
      if (this.listIdApproveAlbum.length > 0) {
        this.$confirm(
            "Bạn có chắc chắn muốn xóa Album ảnh đã chọn?",
            "Thông báo!",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "Có",
              closeOnClickModal: false,
              cancelButtonText: "Không",
            }
        ).then(() => {
          AlbumService.deleteMultiAlbum(this.listIdApproveAlbum)
              .then((res) => {
                if (res.data) {
                  NotifyMessage.leftCornerNotificationSuccess("Xóa album thành công!")
                  this.listIdApproveAlbum = [];
                  this.searchByProperties();
                  this.$store.dispatch("notificationNavbarStore/fetchNotification");
                } else {
                  NotifyMessage.leftCornerNotificationError("Xóa album thất bại")
                }
              })
              .catch((err) => {
                console.log(err);
                NotifyMessage.leftCornerNotificationError("Lỗi xóa ảnh")
              });
        });
      } else {
        NotifyMessage.leftCornerNotificationError("Bạn chưa chọn Album nào")
      }
    },

    checkApproveAlbum(id, boolean) {
      let indexOf = this.listIdApproveAlbum.indexOf(id);
      if (boolean) {
        if (indexOf === -1) {
          this.listIdApproveAlbum.push(id);
        }
      } else {
        if (indexOf !== -1) {
          this.listIdApproveAlbum.splice(indexOf, 1);
        }
      }
    },

    updateMultiApproveAlbumMethod() {
      if (this.listIdApproveAlbum.length > 0) {
        AlbumService.updateMultiApproveAlbum(this.listIdApproveAlbum)
            .then(() => {
              NotifyMessage.leftCornerNotificationSuccess("Duyệt album thành công!")
              this.searchByProperties();
              this.$store.dispatch("notificationNavbarStore/fetchNotification");
            })
            .catch((err) => {
              console.log(err);
              NotifyMessage.leftCornerNotificationError("Duyệt album thất bại");
              this.searchByProperties();
            });
      } else {
        NotifyMessage.leftCornerNotificationError("Chưa có Album nào được chọn!");
      }
    },

    updateMultiUnApproveAlbum() {
      if (this.listIdApproveAlbum.length > 0) {
        AlbumService.updateMultiUnApproveAlbum(this.listIdApproveAlbum)
            .then(() => {
              NotifyMessage.leftCornerNotificationSuccess("Hủy duyệt album thành công!")
              this.searchByProperties();
              this.$store.dispatch("notificationNavbarStore/fetchNotification")
            })
            .catch((err) => {
              console.log(err);
              NotifyMessage.leftCornerNotificationError("Hủy duyệt album thất bại")
              this.searchByProperties();
            });
      } else {
        NotifyMessage.leftCornerNotificationError("Chưa có Album nào được chọn!");
      }
    },
    albumResponseAlbumName(albumResponse) {
      if (albumResponse.urlPictureFirst != null) {
        return albumResponse.albumName;
      } else {
        return albumResponse.albumName + " - No Picture";
      }
    },

    resetCheckAll() {
      this.isCheckAll = false;
      this.listIdApproveAlbum = [];
    }
  },

  beforeMount() {
    this.getTotalRows();
    this.searchByProperties();
  },
};
</script>

<style lang="scss" scoped>
.album-list-page {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-bottom: 24px;

  // ─── Header card ─────────────────────────────────────────────────────────
  .page-header-card {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    padding: 24px 28px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    border: 1px solid #e8edf4;
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(31, 45, 61, 0.08);
    position: relative;
    overflow: hidden;

    &::after {
      content: "";
      position: absolute;
      top: -30px; right: -30px;
      width: 160px; height: 160px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(120,165,231,.22) 0%, rgba(120,165,231,0) 72%);
      pointer-events: none;
    }
  }

  .page-title {
    margin: 0 0 8px;
    color: #303133;
    font-size: 26px;
    font-weight: 700;
  }

  .page-description {
    margin: 0;
    max-width: 640px;
    color: #606266;
    line-height: 1.6;
  }

  .header-badges {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;
  }

  .summary-badge {
    min-width: 140px;
    padding: 14px 16px;
    border-radius: 14px;
    background: #f5f9ff;
    border: 1px solid #dbe8fb;
  }

  .summary-badge__label {
    display: block;
    margin-bottom: 6px;
    color: #909399;
    font-size: 12px;
  }

  .summary-badge__value {
    color: #303133;
    font-size: 20px;
    font-weight: 700;
  }

  // ─── Toolbar ─────────────────────────────────────────────────────────────
  .toolbar-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 16px 20px;
    background: #ffffff;
    border: 1px solid #e8edf4;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(31, 45, 61, 0.06);
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .toolbar-datepicker {
    width: 260px;
  }

  .toolbar-select {
    width: 140px;
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  .btn-action {
    border-radius: 10px !important;
    font-weight: 600;
  }

  .cancel-link { text-decoration: none; }

  // ─── Grid shell ───────────────────────────────────────────────────────────
  .grid-shell {
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    border: 1px solid #e8edf4;
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(31, 45, 61, 0.08);
    padding: 20px 24px;
  }

  .select-bar {
    display: flex;
    align-items: center;
    gap: 14px;
    padding-bottom: 14px;
    margin-bottom: 16px;
    border-bottom: 1px solid #edf2f8;
  }

  .select-bar__count {
    color: #78a5e7;
    font-size: 13px;
    font-weight: 600;
  }

  // ─── Album grid ───────────────────────────────────────────────────────────
  .album-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
    gap: 18px;
  }

  // ─── Album card ───────────────────────────────────────────────────────────
  .album-card {
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    border: 1px solid #edf2f8;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 4px 14px rgba(31, 45, 61, 0.06);
    transition: box-shadow .2s ease, transform .15s ease;

    &:hover {
      box-shadow: 0 10px 28px rgba(31, 45, 61, 0.13);
      transform: translateY(-2px);
    }

    &--selected {
      border-color: #78a5e7;
      box-shadow: 0 0 0 3px rgba(120,165,231,.18), 0 4px 14px rgba(31,45,61,.06);
    }
  }

  .album-card__cover-link { display: block; text-decoration: none; }

  .album-card__cover {
    position: relative;
    height: 180px;
    overflow: hidden;
    background: #f5f7fa;
  }

  .album-card__img {
    width: 100%; height: 180px;
    transition: transform .25s ease;

    /deep/ .el-image__inner { object-fit: cover; width: 100%; height: 100%; }
  }

  .album-card__cover-link:hover .album-card__img {
    transform: scale(1.04);
  }

  .album-card__no-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 8px;
    color: #c0c4cc;
    font-size: 13px;
  }

  .album-card__no-img-icon { font-size: 40px; }

  .album-card__status-badge {
    position: absolute;
    top: 10px; right: 10px;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .03em;
  }

  .badge--visible { background: rgba(103,194,58,.9); color: #fff; }
  .badge--hidden  { background: rgba(64,158,255,.9);  color: #fff; }

  .album-card__info {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 12px 14px 10px;
  }

  .album-card__name-link { text-decoration: none; }

  .album-card__name {
    color: #303133;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.4;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .album-card__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;
    min-height: 46px;
    align-content: flex-start;
  }

  .album-card__meta-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #909399;
    background: #f5f7fa;
    border-radius: 8px;
    padding: 2px 8px;
  }

  .album-card__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .album-card__date {
    font-size: 12px;
    color: #c0c4cc;
  }

  .album-card__actions {
    display: flex;
    gap: 6px;
    padding: 8px 0 2px;
    border-top: 1px solid #f2f4f6;
    margin-top: auto;
  }

  .album-card__action-btn {
    flex: 1;
    border-radius: 8px !important;
    font-size: 12px;
  }

  .album-card__action-btn--danger {
    background: #fef0f0 !important;
    color: #f56c6c !important;
    border-color: #fbc4c4 !important;
  }

  .actions--visible .album-card__action-btn:not(.album-card__action-btn--danger) {
    color: #67c23a;
    border-color: #c2e7b0;
    background: #f0f9eb;
  }

  .actions--hidden .album-card__action-btn:not(.album-card__action-btn--danger) {
    color: #409eff;
    border-color: #b3d8ff;
    background: #ecf5ff;
  }

  // ─── Empty state ─────────────────────────────────────────────────────────
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    min-height: 280px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    border: 1px solid #e8edf4;
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(31, 45, 61, 0.08);
    text-align: center;
    padding: 40px 24px;
  }

  .empty-state__icon {
    display: flex; align-items: center; justify-content: center;
    width: 80px; height: 80px;
    border-radius: 50%;
    background: #edf4ff;
    color: #78a5e7;
    font-size: 36px;
  }

  .empty-state__title { color: #303133; font-size: 20px; font-weight: 700; }
  .empty-state__desc  { color: #606266; line-height: 1.6; max-width: 380px; }

  // ─── Pagination ───────────────────────────────────────────────────────────
  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
  }

  // ─── Dropdown ────────────────────────────────────────────────────────────
  // ─── Input overrides ─────────────────────────────────────────────────────
  /deep/ .el-input .el-input__inner,
  /deep/ .el-select .el-input__inner {
    border-radius: 10px;
    border-color: #dbe4f0;
    height: 38px;
    line-height: 38px;
    transition: all .2s ease;
  }

  /deep/ .el-input .el-input__inner:focus,
  /deep/ .el-select .el-input__inner:focus {
    border-color: #78a5e7;
    box-shadow: 0 0 0 3px rgba(120,165,231,.12);
  }

  /deep/ .el-date-editor .el-range-input { font-size: 13px; }
  /deep/ .el-date-editor--daterange.el-input__inner { border-radius: 10px; border-color: #dbe4f0; }

  // ─── Responsive ──────────────────────────────────────────────────────────
  @media (max-width: 1024px) {
    .album-grid {
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    }
  }

  @media (max-width: 768px) {
    .page-header-card { flex-direction: column; align-items: flex-start; border-radius: 14px; padding: 16px; }
    .header-badges { width: 100%; }
    .summary-badge { flex: 1 1 140px; }

    .toolbar-card { flex-direction: column; align-items: flex-start; border-radius: 12px; }
    .toolbar-left { width: 100%; }
    .toolbar-datepicker, .toolbar-select { width: 100%; }
    .toolbar-right { width: 100%; }
    .toolbar-right .btn-action, .toolbar-right .cancel-link { flex: 1; }

    .grid-shell { padding: 14px; border-radius: 14px; }

    .album-grid {
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      gap: 12px;
    }

    .pagination-wrap { justify-content: center; }
  }
}

.album-dropdown-menu {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.12);

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    font-size: 14px;
    transition: background .15s ease;

    &:hover { background: #f0f6ff; color: #78a5e7; }
    &.is-divided { border-top: 1px solid #edf2f8; }
  }
}
</style>
